export default __webpack_public_path__ + "static/media/mobile.33937a6f.svg";